export const actionTypePrefix = '@@config';
export const reduxKey = '@@config';
